import styled from 'styled-components';

export const Wrapper = styled.div<{ isAtModal?: boolean; disabled?: boolean }>`
  width: 100%;
  height: 165px;

  border: 1px solid #f1f1f1;

  display: flex;
  flex-direction: ${p => (p.isAtModal ? 'Row' : 'Column')};
  align-items: center;
  border-radius: ${p => p.theme.radius.lg};
  padding: ${props =>
    `${props.theme.app.padding.vertical} ${props.theme.app.padding.horizontal}`};
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};

  transition: all 0.4s;

  &:hover {
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1);
  }
`;

export const WrapperAvatar = styled.div<{ background: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 112px;
  height: 112px;
  background: ${props => props.background};

  flex-shrink: 0;

  -webkit-clip-path: polygon(50% 0, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
  clip-path: polygon(50% 0, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%);
`;

export const WrapperMobile = styled.div`
  width: 100%;
  height: 171px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
  border-radius: ${p => p.theme.radius.md};
  padding: ${props =>
    `${props.theme.app.padding.vertical} ${props.theme.app.padding.horizontal}`};
  cursor: pointer;
`;

export const WrapperAvatarMobile = styled.div<{ background: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 72px;
  height: 72px;
  border-radius: 999px;
  background: ${props => props.background};
`;
